module.exports = __webpack_public_path__ + "static/media/CREATIVIDAD.ea988036.svg";